
export interface WsDeliverAppPackage {

  name: string; // portal

  applicationName: string;
  path?: string;
  sourcePath?: string;
  installCommand: string;
  uninstallCommand: string;
  installContext?: string;

  detectionAppExist?: string;
  detectionRegistryKeyPath?: string;
  detectionRegistryValueName?: string;
  detectionRegistryStringComparison?: string;
  detectionFileExist?: string;
  detectionScriptPath?: string;

  vendorName: string;         // AppVendorName
  applicationVersion: string; // AppVersion

  description?: string;
  notes?: string;
  developer?: string;
  owner?: string;
  iconPath?: string;
  intent?: string;
  assignmentGroupId?: string;

  detectionMethod: string;     // not used
  mediaFolderLocation: string; // not used

  stage?: number; // portal

  status?: string; // portal

  job?: any;
  // task?: any;
  // process?: any;
}




export interface WsDeliverApp {
  id: number;
  name: string;
  fields: WsDeliverAppPackage;
}




export const appPackagesDefault: WsDeliverAppPackage[] = [
  {
    "name": "Adobe Reader",
    "vendorName": "Adobe",
    "applicationName": "Adobe Acrobat Reader DC",
    "applicationVersion": "2023.006.20380",
    "installCommand": "AcroRdrDC2300620380_en_US.exe /sAll",
    "uninstallCommand": "msiexec /x {AC76BA86-7AD7-1033-7B44-AC0F074E4100} /qn",
    "detectionMethod": "Registry",
    "mediaFolderLocation": "\\\\server\\software\\AdobeReader"
  },
  {
    "name": "Citrix Workspace",
    "vendorName": "Citrix",
    "applicationName": "Citrix Workspace",
    "applicationVersion": "23.9.0.105",
    "installCommand": "CitrixWorkspaceApp.exe /silent",
    "uninstallCommand": "CitrixWorkspaceApp.exe /uninstall /silent",
    "detectionMethod": "Registry",
    "mediaFolderLocation": "\\\\server\\software\\Citrix"
  },
  {
    "name": "Google Chrome",
    "vendorName": "Google",
    "applicationName": "Google Chrome",
    "applicationVersion": "118.0.5993.90",
    "installCommand": "ChromeSetup.exe /silent /install",
    "uninstallCommand": "msiexec /x {C1A1F1D2-3B4C-4D5E-9F6A-7B8C9D0E1F2A} /qn",
    "detectionMethod": "File",
    "mediaFolderLocation": "\\\\server\\software\\Chrome"
  },
  {
    "name": "VLC Media Player",
    "vendorName": "VideoLAN",
    "applicationName": "VLC Media Player",
    "applicationVersion": "3.0.20",
    "installCommand": "vlc-3.0.20-win64.exe /S",
    "uninstallCommand": "\"C:\\Program Files\\VideoLAN\\VLC\\uninstall.exe\" /S",
    "detectionMethod": "File",
    "mediaFolderLocation": "\\\\server\\software\\VLC"
  },
  {
    "name": "OBS Studio",
    "vendorName": "OBS Project",
    "applicationName": "OBS Studio",
    "applicationVersion": "30.0.0",
    "installCommand": "OBS-Studio-30.0-Full-Installer-x64.exe /S",
    "uninstallCommand": "\"C:\\Program Files\\obs-studio\\uninstall.exe\" /S",
    "detectionMethod": "File",
    "mediaFolderLocation": "\\\\server\\software\\OBS"
  },
  {
    "name": "Notepad++",
    "vendorName": "Don Ho",
    "applicationName": "Notepad++",
    "applicationVersion": "8.5.6",
    "installCommand": "npp.8.5.6.Installer.x64.exe /S",
    "uninstallCommand": "\"C:\\Program Files\\Notepad++\\uninstall.exe\" /S",
    "detectionMethod": "File",
    "mediaFolderLocation": "\\\\server\\software\\Notepad++"
  },
  {
    "name": "Microsoft Teams",
    "vendorName": "Microsoft",
    "applicationName": "Microsoft Teams",
    "applicationVersion": "1.6.00.12345",
    "installCommand": "Teams_windows_x64.exe /quiet",
    "uninstallCommand": "msiexec /x {731F6BAA-A986-45A4-8936-7C3AAAAA760B} /qn",
    "detectionMethod": "Registry",
    "mediaFolderLocation": "\\\\server\\software\\Teams"
  },
  {
    "name": "Zoom",
    "vendorName": "Zoom Video Communications",
    "applicationName": "Zoom",
    "applicationVersion": "5.16.2",
    "installCommand": "ZoomInstallerFull.exe /quiet",
    "uninstallCommand": "msiexec /x {C0A1F1D2-3B4C-4D5E-9F6A-7B8C9D0E1F2B} /qn",
    "detectionMethod": "Registry",
    "mediaFolderLocation": "\\\\server\\software\\Zoom"
  },
  {
    "name": "Firefox",
    "vendorName": "Mozilla",
    "applicationName": "Mozilla Firefox",
    "applicationVersion": "118.0.2",
    "installCommand": "Firefox Setup 118.0.2.exe /S",
    "uninstallCommand": "\"C:\\Program Files\\Mozilla Firefox\\uninstall\\helper.exe\" /S",
    "detectionMethod": "File",
    "mediaFolderLocation": "\\\\server\\software\\Firefox"
  },
  {
    "name": "WinRAR",
    "vendorName": "RARLAB",
    "applicationName": "WinRAR",
    "applicationVersion": "6.23",
    "installCommand": "winrar-x64-623.exe /S",
    "uninstallCommand": "\"C:\\Program Files\\WinRAR\\Uninstall.exe\" /S",
    "detectionMethod": "File",
    "mediaFolderLocation": "\\\\server\\software\\WinRAR"
  },
];




export const getItemFieldValue = (item: any, field: string, defaultValue?: string) => {
  if (item && item[field]) {
    return `${item[field]}`;
  } else {
    if (defaultValue) {
      return `${field}: ${defaultValue}`;
    } else {
      return '';
    }
  }
};
